export function createIcon() {
  return (
    <svg
      version="1.1"
      id="Ebene_1"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="0 0 283.465 283.465"
      enableBackground="new 0 0 283.465 283.465"
    >
      <g id="g1750" transform="matrix(1.5015303,0,0,1.5015303,-72.345181,-7.9452976)">
        <g id="g1724">
          <defs id="defs1715">
            <rect height="179.625" width="183.321" y="9.8400002" x="49.436001" id="SVGID_1_" />
          </defs>
          <clipPath id="SVGID_2_">
            <rect height="179.625" width="183.321" y="9.8400002" x="49.436001" id="SVGID_1_" />
          </clipPath>
          <path
            id="path1720"
            d="m 167.467,147.596 c -7.451,3.9 -15.912,6.139 -24.893,6.139 -29.692,0 -53.771,-24.073 -53.771,-53.77 0,-19.081 9.976,-35.806 24.971,-45.349 L 105.203,39.77 C 85.098,52.274 71.71,74.548 71.708,99.964 c 0,39.142 31.722,70.862 70.867,70.86 12.098,0.002 23.486,-3.027 33.462,-8.383 z m 0,0"
            clipPath="url(#SVGID_2_)"
          />
          <path
            id="path1722"
            d="m 147.266,181.121 0.004,8.908 c 31.227,-1.609 58.264,-19.096 73.168,-44.557 l -7.689,-4.438 c -13.377,22.8 -37.538,38.499 -65.483,40.087 z m 0,0"
            clipPath="url(#SVGID_2_)"
          />
        </g>
        <path
          id="path1726"
          d="m 147.266,9.902 v 8.903 c 42.721,2.434 76.615,37.845 76.615,81.159 0,11.629 -2.463,22.673 -6.87,32.684 l 7.742,4.466 c 5.134,-11.335 8.003,-23.902 8.008,-37.15 0,-48.228 -37.872,-87.616 -85.495,-90.062 z m 0,0"
        />
        <path
          id="path1728"
          d="M 172.919,90.387 183.37,90.39 C 179.016,71.857 162.428,58.039 142.57,58.041 122.709,58.04 106.119,71.859 101.778,90.386 h 10.449 c 4.072,-12.883 16.113,-22.234 30.347,-22.234 14.225,0.001 26.275,9.352 30.345,22.235 z m 0,0"
        />
        <path
          id="path1730"
          d="m 100.644,99.964 c 0,23.167 18.777,41.923 41.927,41.926 23.152,0 41.929,-18.774 41.929,-41.926 0.003,-0.062 -0.013,-0.122 -0.016,-0.167 l -10.11,0.001 c -0.005,0.044 0.012,0.104 0.014,0.166 -0.002,17.566 -14.252,31.814 -31.816,31.809 -17.566,0.005 -31.815,-14.243 -31.812,-31.809 -0.003,-0.062 10e-4,-0.122 10e-4,-0.167 h -10.114 c -0.005,0.045 -0.001,0.106 -0.003,0.167 z m 0,0"
        />
        <g id="g1742">
          <defs id="defs1733">
            <rect height="179.625" width="183.321" y="9.8400002" x="49.436001" id="SVGID_3_" />
          </defs>
          <clipPath id="SVGID_4_">
            <rect height="179.625" width="183.321" y="9.8400002" x="49.436001" id="SVGID_3_" />
          </clipPath>
          <path
            id="path1738"
            d="m 213.431,99.964 c 0,-12.731 -3.38,-24.682 -9.259,-35.009 l -14.825,8.553 c 4.425,7.819 6.991,16.834 6.995,26.456 -0.004,17.336 -8.248,32.7 -20.979,42.54 l 8.626,14.93 c 17.832,-12.866 29.442,-33.797 29.442,-57.47 z m 0,0"
            clipPath="url(#SVGID_4_)"
          />
          <path
            id="path1740"
            d="m 99.453,179.166 c 11.521,6.285 24.542,10.16 38.418,10.863 v -8.906 c -12.256,-0.705 -23.76,-4.115 -33.967,-9.637 z m 0,0"
            clipPath="url(#SVGID_4_)"
          />
        </g>
        <path
          id="path1744"
          d="m 91.449,174.24 4.449,-7.717 C 74.968,151.82 61.272,127.489 61.272,99.964 c 0,-43.319 33.88,-78.726 76.602,-81.159 V 9.902 c -47.62,2.446 -85.494,41.836 -85.489,90.062 0,30.814 15.469,58.009 39.064,74.276 z m 0,0"
        />
        <path
          id="path1746"
          d="m 179.797,39.71 -8.534,14.793 c 4.815,3.05 9.136,6.841 12.763,11.232 l 14.959,-8.646 C 193.725,50.193 187.208,44.301 179.797,39.71 Z m 0,0"
        />
        <path
          id="path1748"
          d="m 113.497,35.35 8.617,14.901 c 6.303,-2.6 13.202,-4.054 20.461,-4.054 7.184,0 14.041,1.422 20.314,3.993 l 8.614,-14.904 c -8.845,-3.963 -18.622,-6.179 -28.933,-6.184 -10.358,0.004 -20.198,2.253 -29.073,6.248 z m 0,0"
        />
      </g>
    </svg>
  );
}
